import type { Schema } from '@cli-types/core-engine/schema.js'
import type { DevModeIntegrationArtifact } from '@cli-types/next-adapter/generators.js'
import { buildSingleDevModeSnippets } from './build-single-dev-mode-snippets.js'
import { createDevModeIntegrationArtifact } from './create-dev-mode-integration-artifact.js'
export function buildSingleDevModeIntegration(
  schema: Schema,
  adminDir: string,
  actionImportPath: string,
  adminImportAlias?: string
): DevModeIntegrationArtifact {
  return createDevModeIntegrationArtifact(
    schema,
    'single',
    adminDir,
    buildSingleDevModeSnippets(schema, actionImportPath, adminImportAlias),
    [],
    adminImportAlias
  )
}
